var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeerserkerDesignLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#002337;}\n\t.st1{fill:#00354E;}\n\t.st2{fill:#009FE3;stroke:#DCDCDC;stroke-width:20;stroke-miterlimit:10;}\n\t.st3{fill:#00354E;stroke:#DCDCDC;stroke-width:20;stroke-miterlimit:10;}\n\t.st4{fill:#002337;stroke:#DCDCDC;stroke-width:20;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M996.2,1200H203.8C91.3,1200,0,1108.7,0,996.2V203.8C0,91.3,91.3,0,203.8,0h792.3 C1108.7,0,1200,91.3,1200,203.8v792.3C1200,1108.7,1108.7,1200,996.2,1200z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165,1012.6l439.6-800.8L1200,538.7V200c0-110.4-89.5-200-200-200H200C89.5,0,0,89.5,0,200v800 c0,110.4,89.5,200,200,200h306.4L165,1012.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M691.1,530.7l-120,69.3l-3.4,2c-13.1,7.6-27.8,6.7-39.4,0.1c0.1-1.4,0.1-2.8,0-4.2 c-0.8-12.3-7.3-24.4-19.6-31.4l-0.3-0.2L386,496.2c-26.2-15-59,3.7-59,33.8v416.4l-104,59.6c-35,20.1-78.7-5-78.7-45.1V239.7 c0-40.1,43.7-65.1,78.7-45.1l104,59.6l66.8,38.3L559,387.2l137.6,78.9C717.3,483.1,715.5,516.7,691.1,530.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1029.7,748.2l-624.6,360.6c-34.7,20-78.1-5-78.1-45.1V530c0-30.1,32.8-48.8,59-33.8l122.4,70.1l0.3,0.2 c12.3,7.1,18.8,19.1,19.6,31.4c-1.1,0.6-2.2,1.3-3.3,2.1c-9.9,7-16.7,18.5-16.7,32.3v142.5c0,28.3,28.4,46.7,53.5,37 c0.5-0.2,1-0.4,1.5-0.6c1.5-0.6,2.9-1.3,4.3-2.2l123.4-71.3c0.4-0.2,0.8-0.4,1.1-0.7l0.1-0.1c1-0.6,1.9-1.2,2.8-1.9l165.2-95.4 l68.9-39.8l100.5,58C1064.4,678.1,1064.4,728.2,1029.7,748.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M525.1,600l3.3,2.1c11.5,6.6,26.2,7.5,39.4-0.1l3.4-2l120-69.3c24.4-14.1,26.2-47.6,5.6-64.7L559,387.2 l-165.3-94.7L327,254.2v-118c0-40.1,43.4-65.1,78.1-45.1l624.6,360.6c34.7,20,34.7,70.1,0,90.2l-100.5,58l-68.9,39.8l-165.2,95.4 l-73,42.1l-60.2,34.5c-25.1,9.6-53.5-8.8-53.5-37V632.3C508.4,618.5,515.2,607,525.1,600"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeerserkerDesignLogo);
export default __webpack_public_path__ + "static/media/beerserker-design-logo.7505d97e6099ab70729cc29e9b50b6bc.svg";
export { ForwardRef as ReactComponent };